module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_07_17_us_baton-route-police-shooting_index.html_plot.ad17009c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_07_17_us_baton-route-police-shooting_index.html_plot.png
// module id = 375
// module chunks = 0